import type { NavigateFunction } from "react-router";

/**
 * Navigates back.
 *
 * If there is no history (e.g. in a new tab), navigates to the default path.
 */
export function navigateBack(
	navigateFn: NavigateFunction,
	defaultPath: string,
) {
	if (window.history?.length && window.history.length > 1) {
		navigateFn(-1);
	} else {
		navigateFn(defaultPath);
	}
}
